import { Controller } from "@hotwired/stimulus"
import { installFilterHotkey } from "../../utils/filter-hotkey.util"

// Connects to data-controller="realities--filter-menu"
// Handles UI state for the realities filter menu
export default class extends Controller {
  static targets = [
    "filterButton",
    "filterMenu",
    "filterItem",
    "filterContent",
    "activeStatusStatus",
    "activeStatusPropertyType",
    "activeStatusOrder"
  ]

  connect() {
    this.#initializeActiveStatus()
    this.removeFilterHotkey = installFilterHotkey(this)
  }

  disconnect() {
    this.removeFilterHotkey?.()
  }

  #initializeActiveStatus() {
    const urlSearchParams = new URLSearchParams(window.location.search)

    if (this.hasActiveStatusStatusTarget) {
      this.toggleActiveStatus(this.#toggleChecker(urlSearchParams, ["status"]), this.activeStatusStatusTarget)
    }
    if (this.hasActiveStatusPropertyTypeTarget) {
      this.toggleActiveStatus(
        this.#toggleChecker(urlSearchParams, ["propertyType"]),
        this.activeStatusPropertyTypeTarget
      )
    }
    if (this.hasActiveStatusOrderTarget) {
      this.toggleActiveStatus(this.#toggleChecker(urlSearchParams, ["order"]), this.activeStatusOrderTarget)
    }
  }

  #toggleChecker(urlSearchParams, keys) {
    return keys.some((key) => urlSearchParams.has(key))
  }

  toggleActiveStatus(isActive, target) {
    if (isActive) {
      target.classList.remove("d-none")
    } else {
      target.classList.add("d-none")
    }
  }

  openFilterMenu() {
    this.filterMenuTarget.showPopover()
    this.filterButtonTarget.classList.add("filter-button--active")
  }

  closeFilterMenu() {
    this.filterMenuTarget.hidePopover()
    this.filterButtonTarget.classList.remove("filter-button--active")
  }

  selectFilter(event) {
    const { currentTarget } = event
    const selectedId = currentTarget.dataset.id

    this.filterItemTargets.forEach((el) => {
      el.classList.toggle("sidebar__tab--active", el === currentTarget)
    })

    this.filterContentTargets.forEach((el) => {
      el.classList.toggle("tab-content--hidden", el.id !== selectedId)
    })
  }
}
